<template>
  <ModalDefault modal_id="variablesModal"
                header="y"
                size="modal-lg modal-dialog-scrollable"
                style_header=""
                :modal_header="this.getTranslations('expression_380')"
                icon="bx bx-code mr-1">
    <div class="px-2 py-2 pb-3" slot="body">
      <div class="row px-2">
        <div class="col-12">
          <h5 class="title-color">{{ getTranslations('expression_836') }}</h5>
          <span>
             {{ getTranslations('expression_837') }}
          </span>
        </div>
        <div class="col-12 ">
          <div class="border shadow-sm title-color px-4 py-2">
            <code>{{ variable_name }}</code> <i class="bx bxs-right-arrow-alt px-3"></i> {{ getTranslations('expression_838') }}
          </div>
        </div>
        <div v-if="true" class="col-12 ">
          <div class="border shadow-sm title-color px-4 py-2">
            <code>{{ variable_link }}</code> <i class="bx bxs-right-arrow-alt px-3"></i>
            {{ channels.channel.type_key === 1 ? getTranslations('expression_839') : getTranslations('expression_1195')}}
          </div>
        </div>
        <div class="col-12 ">
          <div class="border shadow-sm title-color px-4 py-2">
            <code>{{ variable_operator }}</code> <i class="bx bxs-right-arrow-alt px-3"></i> {{ getTranslations('expression_840') }}
          </div>
        </div>
        <div class="col-12 ">
          <div class="border shadow-sm title-color px-4 py-2">
            <code>{{ variable_department }}</code> <i class="bx bxs-right-arrow-alt px-3"></i> {{ getTranslations('expression_841') }}
          </div>
        </div>
        <div class="col-12 ">
          <div class="border shadow-sm title-color px-4 py-2">
            <code>{{ variable_protocol }}</code> <i class="bx bxs-right-arrow-alt px-3"></i> {{ getTranslations('expression_842') }}
          </div>
        </div>

      </div>
      <div class="row px-2 pt-3 pb-2">
        <div class="col-12">
          <h5 class="title-color">{{ getTranslations('expression_843') }}</h5>
          <span>
            {{ getTranslations('expression_844') }}
            <code class="" v-html="(channels.channel.type_key === 0 || !channels.channel.type_key) ? '*' : '**'"></code>
            {{ getTranslations('expression_264') }}<code class="" v-html="(channels.channel.type_key === 0 || !channels.channel.type_key) ? '*' : '**'">*</code>
            <i class="bx bxs-right-arrow-alt"></i> {{ getTranslations('expression_845') }} <strong>{{ getTranslations('expression_264') }}</strong>
          </span>
        </div>
        <div class="col-12 ">
          <div class="border shadow-sm title-color px-4 py-2">
            <code class="font-weight-bold" v-html="(channels.channel.type_key === 0 || !channels.channel.type_key) ? '*' : '**'"></code>
            <small class="text-gray-600 pl-2">({{ getTranslations('expression_846') }}<span v-html="(channels.channel.type_key === 0 || !channels.channel.type_key) ? '' : ` - 2 ${ getTranslations('expression_463') }`"></span>)</small>
            <i class="bx bxs-right-arrow-alt px-3"></i> {{ getTranslations('expression_847') }} <strong>{{ getTranslations('expression_848') }}</strong> {{ getTranslations('expression_851') }}
          </div>
        </div>
        <div class="col-12 ">
          <div class="border shadow-sm title-color px-4 py-2">
            <code class="font-weight-bold" v-html="(channels.channel.type_key === 0 || !channels.channel.type_key) ? '_' : '__'"></code>
            <small class="text-gray-600 pl-2">({{ getTranslations('expression_852') }}<span v-html="(channels.channel.type_key === 0 || !channels.channel.type_key) ? '' : ` - 2 ${ getTranslations('expression_463') }`"></span>)</small>
            <i class="bx bxs-right-arrow-alt px-3"></i> {{ getTranslations('expression_847') }} <i>{{ getTranslations('expression_849') }}</i> {{ getTranslations('expression_851') }}
          </div>
        </div>
        <div class="col-12 ">
          <div class="border shadow-sm title-color px-4 py-2">
            <code class="font-weight-bold" v-html="(channels.channel.type_key === 0 || !channels.channel.type_key) ? '~' : '~~'"></code>
            <small class="text-gray-600 pl-2">({{ getTranslations('expression_853') }} "til"<span v-html="(channels.channel.type_key === 0 || !channels.channel.type_key) ? '' : ` - 2 ${ getTranslations('expression_463') }`"></span>)</small>
            <i class="bx bxs-right-arrow-alt px-3"></i> {{ getTranslations('expression_847') }} <del>{{ getTranslations('expression_850') }}</del> {{ getTranslations('expression_851') }}
          </div>
        </div>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../general/ModalDefault";
import {mapGetters, mapState} from "vuex";

export default {
  name: "ModalVariables",
  components: {
    ModalDefault,
  },
  computed: {
    ...mapState(['channels', 'sources']),
    ...mapGetters([])
  },
  data() {
    return {
      variable_name: "{{NAME}}",
      variable_link: "{{LINK}}",
      variable_operator: "{{OPERATOR}}",
      variable_protocol: "{{PROTOCOL}}",
      variable_department: "{{DEPARTMENT}}",
    }
  }
}
</script>

<style scoped>

</style>
